export const FeedPostVisibilityValues = {
  everyone: 'everyone',
  followers_only: 'followers_only',
} as const;

export type FeedPostVisibility = (typeof FeedPostVisibilityValues)[keyof typeof FeedPostVisibilityValues];

export const resolveFeedPostVisibility = (value?: string | null): FeedPostVisibility =>
  value === FeedPostVisibilityValues.followers_only
    ? FeedPostVisibilityValues.followers_only
    : FeedPostVisibilityValues.everyone;
